<div id="show-quiz" role="main" *ngIf="!loading">
    <div class="card">
    <div class="card-header text-center">
        <h4 class="text-center">
            {{quizEnvelop.subjectName}} Quiz {{quizEnvelop.server_quiz_envelop_id}}
            <span>( {{quizEnvelop.isCompleted ? 'Completed' : 'Not Completed'}} )</span>
           </h4>
        <h5> Level: {{quizEnvelop.level_name}} <span *ngIf="learner.server_student_id!=0">- {{learner.countryname}}</span></h5>


    </div>

    <div id="card{{question.server_question_id}}" [ngClass]="{activecard: questionId==question.server_question_id, inactivecard:questionId!=question.server_question_id}" class="questioncard" *ngIf="question">
        <div class="text-center question-title" >
            <a [routerLink]="['/student/quiz/show',learner.server_user_id,quizEnvelop.server_quiz_envelop_id]"   class="btn btn-outline-primary"> Back to Start</a>
            Question  {{questionIndex+1}} of {{quizEnvelop.question_count}}
            <a [routerLink]="['/student/quiz/show',learner.server_user_id,quizEnvelop.server_quiz_envelop_id]" class="btn btn-outline-primary"> Back to Start</a>
        </div>
        <div  class="text-center question-body">
           <div>
            <span *ngIf="question.server_question_id!=0" [appMath]="question.questionText"> </span>
           </div>
           <div class="question-answer-field">

            <app-do-question *ngIf="question.is_multipart==0 && question.server_question_id!=0"
                [question]="question"
                [learner] ="learner"
                [quizEnvelop]="quizEnvelop"
                [questionIndex]="questionIndex"
                [isLastQuestion]="isLastQuestion">
            </app-do-question>

            <app-do-question-prompt *ngIf="question.is_multipart==1 && question.server_question_id!=0"
                [question]="question"
                [learner] ="learner"
                [quizEnvelop]="quizEnvelop"
                [questionIndex]="questionIndex"
                [isLastQuestion]="isLastQuestion">
             </app-do-question-prompt>


            </div>
        </div>

        </div>
    </div>
</div>
<span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
